import React from "react";
import {
    Box,
    SimpleGrid,
    Heading,
    Text,
    useColorModeValue,
    useDisclosure
} from "@chakra-ui/react";
import DataTableCard from "../dataTables/components/DataTableCard";
import SalesAgreementsModal from "./components/SalesAgreementsModal";

import { MdBusinessCenter } from "react-icons/md";

export default function Sales() {
    const textColor = useColorModeValue("secondaryGray.900", "white");

    // Modal controls
    const {
        isOpen: isSalesAgreementsOpen,
        onOpen: onSalesAgreementsOpen,
        onClose: onSalesAgreementsClose
    } = useDisclosure();

    const salesReports = [
        {
            id: "sales-agreements",
            title: "הסכמי מכירות",
            description: "צפייה בהסכמי מכירות של החברות במערכת",
            icon: MdBusinessCenter,
            color: "green",
            onClick: onSalesAgreementsOpen,
            buttonText: "צפייה בהסכמים"
        }
    ];

    return (
        <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
            <Box mb="20px">
                <Heading size="lg" color={textColor} mb="4">
                    מכירות
                </Heading>
                <Text color="secondaryGray.600" fontSize="md">
                    ניהול והצגת נתוני מכירות והסכמים
                </Text>
            </Box>

            <SimpleGrid
                columns={{ base: 1, md: 2, lg: 3 }}
                spacing="20px"
                mb="20px"
            >
                {salesReports.map((report) => (
                    <DataTableCard
                        key={report.id}
                        title={report.title}
                        description={report.description}
                        icon={report.icon}
                        color={report.color}
                        onClick={report.onClick}
                        buttonText={report.buttonText}
                    />
                ))}
            </SimpleGrid>

            {/* Modals */}
            <SalesAgreementsModal
                isOpen={isSalesAgreementsOpen}
                onClose={onSalesAgreementsClose}
            />
        </Box>
    );
}
